import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/addItemSavingsBasket/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { ADD_ITEM_SAVINGS_BASKET } from 'constants/TestTarget';

const showAddItemSavingsBasketSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: Boolean(testReady && experience === ADD_ITEM_SAVINGS_BASKET.CHALLENGER_ONE),
    challengerTwo: Boolean(testReady && experience === ADD_ITEM_SAVINGS_BASKET.CHALLENGER_TWO)
}));

export { showAddItemSavingsBasketSelector };
